import { apiClient } from "../config";
async function inviteUser(data: any) {
  const res = await apiClient.post("/admin/users/invitation", data);
  return res.data;
}

export default inviteUser;
